<table *ngIf="canManageTransactionErrors">
  <tr>
    <td><div class="connection-status" [class.connected]="signalRService.isConnected()" [class.disconnected]="!signalRService.isConnected()"></div></td>
    <td><a (click)="errorsButtonClicked()" class="btn" [class]="{ 'error': !hasSeenIncomingError, 'staticError': staticError }" ><i class="dx-icon-warning"></i></a></td>
  </tr>
</table>
<dx-popup *ngIf="popupVisible"
          title="{{languageService.LNG('Label.Transactions')}}"
          width="1600"
          height="800"
          hideOnOutsideClick="true"
          (onShowing)="popupOnShowing($event)"
          (onHiding)="popupOnHiding($event)"
          [(visible)]="popupVisible">

  <div *dxTemplate="let c of 'content'">
    <dx-data-grid [dataSource]="transactions"
                  noDataText=""
                  rowAlternationEnabled="true"
                  columnAutoWidth="true"
                  [scrolling]="{mode: 'virtual'}"
                  [height]="transactionsGridHeight"
                  [columns]="transactionsGridColumns">
      <dxo-paging [enabled]="transactionsGridPagingEnabled" [pageSize]="13"></dxo-paging>
      <dxo-group-panel [visible]="transactionsGridGroupPanelVisible"></dxo-group-panel>
      <dxo-filter-row [visible]="transactionsGridEnableFiltering"></dxo-filter-row>
      <div *dxTemplate="let template of 'buttonOpenTemplate'">
        <dx-button [style.visibility]="template.data.TransactionStatusId === -2 ? 'inherit' : 'hidden'" text="{{languageService.LNG('Label.Open')}}" type="default" (click)="openTransaction(template.data)"></dx-button>
      </div>

      <div *dxTemplate="let template of 'buttonCloseTemplate'">
        <dx-button [style.visibility]="template.data.TransactionStatusId === -2 ? 'inherit' : 'hidden'" text="{{languageService.LNG('Label.Button.Close')}}" type="normal" (click)="closeTransaction(template.data)"></dx-button>
      </div>

      <div *dxTemplate="let t of 'groupCellTemplate'">
        <table class="groupTable">
          <tr>
            <td><span class="caption">{{t.column.caption}}</span>: </td>
            <td>{{t.value}}</td>
            <td style="padding-left:5px">
              <div *ngIf="showCloseOpenButton(t)">
                <dx-button text="{{languageService.LNG('Label.Open')}}" type="default" (click)="openTransactions(t)"></dx-button>
              </div>
            </td>
            <td style="padding-left:5px">
              <div *ngIf="showCloseOpenButton(t)">
                <dx-button text="{{languageService.LNG('Label.Button.Close')}}" type="normal" (click)="closeTransactions(t)"></dx-button>
              </div>
            </td>
            <td class="caption" style="padding-left:5px">
              (<span>{{t.summaryItems[0].value.statusId2Count}} {{languageService.LNG('Label.transactions')}}</span>)
            </td>
          </tr>
        </table>
      </div>
      <!-- NOTE!! the grid is hardcoded to only handle ONE summary item -->
      <dxo-summary [calculateCustomSummary]="transactionGridCalculateGroupedTransactionIds">
        <dxi-group-item  
              name="transactionId"
              summaryType="custom"
              [showInGroupFooter]="false"
              [alignByColumn]="false" >
        </dxi-group-item>
      </dxo-summary>
    </dx-data-grid>
  </div>
</dx-popup>

<dx-load-panel shadingColor="rgba(0,0,0,0.4)" message="" [visible]="isBusy" [hideOnOutsideClick]="false"></dx-load-panel>
